<div id="payment-view" class="sr-form">
  <form id="payment-form">
    <nav id="payment-methods" class="sr-form-row" [hidden]="singleType">
      <ul>
        <li class="visible">
          <input
            class="input-stripe"
            type="radio"
            name="payment"
            id="payment-card"
            value="card"
            [(ngModel)]="typeView"
          />
          <label for="payment-card">Card</label>
        </li>
        <li class="visible">
          <input
            class="input-stripe"
            type="radio"
            name="payment"
            id="payment-type_iban_element"
            value="type_iban_element"
            [(ngModel)]="typeView"
          />
          <label for="payment-type_iban_element">SEPA Debit</label>
        </li>
      </ul>
    </nav>
    <div class="sr-form-row payment-info card visible" [class.visible]="typeView == 'card'">
      <div class="sr-combo-inputs">
        <div class="sr-combo-inputs-row">
          <div class="sr-input sr-element" id="card-element"></div>
        </div>
      </div>
    </div>
    <div class="sr-form-row payment-info type_iban_element" [class.visible]="typeView == 'type_iban_element'">
      <div class="sr-combo-inputs-row">
        <div class="sr-input sr-element" id="iban-element">
          <!-- A Stripe Element will be inserted here. -->
        </div>
      </div>
      <div id="bank-name"></div>
      <!-- Display mandate acceptance text. -->
      <div class="sr-legal-text au-becs-debits">
        {{'BILLING_INFO.SEPA_POLITICS_TEXT' | translate}}
      </div>
    </div>
    <div id="error-message" class="sr-field-error" role="alert"></div>
  </form>
</div>
